export enum UserOptionMemberChargeFrom {
  /** 從商戶 */
  Tenant = 0,
  /** 從會員 */
  Member = 1,
}

export enum UserOptionMemberChargeTime {
  /** 成立時 */
  Verified = 0,
  /** 對帳時 */
  Reported = 1,
}
